<template>
  <div>
    <v-icon @click="dialog = true">mdi-pencil</v-icon>
    <SysDialog
      v-model="dialog"
      :titulo="TITULO_DIALOG"
      :largura="LARGURA_DIALOG"
      @click:primary="editar()"
    >
      <div class="row">
        <div class="col-6 pb-0">
          <TextFieldFormatadorDeValor
            v-model="editar_item.lote_minimo"
            label="Lote Minimo"
            outlined
            :error-messages="LOTE_MINIMO_ERRORS"
            @input="$v.editar_item.lote_minimo.$touch()"
            @blur="$v.editar_item.lote_minimo.$touch()"
          />
        </div>

        <div class="col-6 pb-0">
          <TextFieldFormatadorDeValor
            v-model="editar_item.tempo_medio_ressuprimento"
            label="Tempo Ressuprimento"
            outlined
            :error-messages="TEMPO_RESSUPRIMENTO_ERRORS"
            :messages="TEMPO_RESSUPRIMENTO_ZERO"
            @input="$v.editar_item.tempo_medio_ressuprimento.$touch()"
            @blur="$v.editar_item.tempo_medio_ressuprimento.$touch()"
          />
        </div>
      </div>

      <div class="row mt-0">
        <div class="col-4 pb-0">
          <v-text-field
            v-model="editar_item.data_limite"
            label="Data Limite*"
            type="date"
            class="mb-3"
            messages="Data de vencimento do fator de atuação"
            outlined
            :error-messages="DATA_LIMITE_ERRORS"
            @input="$v.editar_item.data_limite.data.$touch()"
            @blur="$v.editar_item.data_limite.data.$touch()"
          />
        </div>
        <div class="col-4 pb-0">
          <v-select
            outlined
            v-model="editar_item.tipo_ajuste"
            :items="tipo_ajuste"
            label="Selecione o Tipo de Ajuste*"
            item-value="id"
            item-text="tipo"
            :error-messages="TIPO_AJUSTE_ERRORS"
            @input="$v.editar_item.tipo_ajuste.$touch()"
            @blur="$v.editar_item.tipo_ajuste.$touch()"
          />
        </div>
        <div class="col-4 pb-0">
          <v-text-field
            v-model="editar_item.percentual_ajuste"
            label="Informe o Percentual*"
            placeholder="Ex: 50"
            suffix="%"
            outlined
            :error-messages="PERCENTUAL_AJUSTE_ERRORS"
            @input="$v.editar_item.percentual_ajuste.$touch()"
            @blur="$v.editar_item.percentual_ajuste.$touch()"
          />
        </div>
      </div>
    </SysDialog>
  </div>
</template>

<script>
import SysDialog from '@/components/padraoDeLayout/SysDialog.vue'
import TextFieldFormatadorDeValor from '@/components/utils/TextFieldFormatadorDeValor.vue';
import { salvarEditarProdutos } from "../Api";
import { required, decimal } from "vuelidate/lib/validators";

const verificarMaiorQueZero = (value) => value > 0;

export default {
  components: {
    SysDialog,
    TextFieldFormatadorDeValor
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    produtos_selecionados: {
      type: Array,
      required: true
    }
  },
  data: () => ({
    dialog: false,
    editar_item: {},
    tipo_ajuste: [
      { id: 1, tipo: "Aumento" },
      { id: 2, tipo: "Redução" },
    ],
  }),
  watch: {
    dialog(valor) {
      if (valor) this.editar_item = Object.assign({}, this.item);
    }
  },
  validations: {
    editar_item: {
      lote_minimo: { decimal, verificarMaiorQueZero },
      tempo_medio_ressuprimento: { decimal },
      fator_atuacao: { decimal, verificarMaiorQueZero },
      data_limite: {
        required,
        posteriorHoje() {
          const hoje = new Date().getTime();
          const data = new Date(this.editar_item.data_limite).getTime();

          if (hoje >= data) return false;
          return true;
        }
      },
      tipo_ajuste: { required },
      percentual_ajuste: {
        required,
        ajusteValido () {
          if (this.editar_item.tipo_ajuste == 2 && this.editar_item.percentual_ajuste >= 100) return false;
          return true;
        },
      },
    }
  },
  computed: {
    TITULO_DIALOG() {
      return this.produtos_selecionados.length == 0
        ? `Editar o produto ${this.item.descricao_produto}`
        : 'Editar multiplos produtos';
    },
    LARGURA_DIALOG() {
      return this.produtos_selecionados.length == 0 ? 900 : 600;
    },
    LOTE_MINIMO_ERRORS() {
      const errors = [];
      if (!this.$v.editar_item.lote_minimo.$dirty) return errors;
      !this.$v.editar_item.lote_minimo.decimal && errors.push("Campo Obrigatório.");
      !this.$v.editar_item.lote_minimo.verificarMaiorQueZero && errors.push("Deve ser maior que 0 (Zero).");
      return errors;
    },
    TEMPO_RESSUPRIMENTO_ERRORS() {
      const errors = [];
      if (!this.$v.editar_item.tempo_medio_ressuprimento.$dirty) return errors;
      !this.$v.editar_item.tempo_medio_ressuprimento.decimal && errors.push("Campo Obrigatório.");
      return errors;
    },
    TEMPO_RESSUPRIMENTO_ZERO() {
      return "Ao zerar, o ressuprimento será convertido para automatico.";
    },
    FATOR_ATUACAO_ERRORS() {
      const errors = [];
      if (!this.$v.editar_item.fator_atuacao.$dirty) return errors;
      !this.$v.editar_item.fator_atuacao.decimal && errors.push("Campo Obrigatório.");
      !this.$v.editar_item.fator_atuacao.verificarMaiorQueZero && errors.push("Deve ser maior que 0 (Zero).");
      return errors;
    },
    DATA_LIMITE_ERRORS() {
      const errors = [];
      if (!this.$v.editar_item.data_limite.$dirty) return errors;
      !this.$v.editar_item.data_limite.required && errors.push("Campo Obrigatório.");
      !this.$v.editar_item.data_limite.posteriorHoje && errors.push("Data limite deve ser posterior a hoje.");
      return errors;
    },
    TIPO_AJUSTE_ERRORS() {
      const errors = [];
      if (!this.$v.editar_item.tipo_ajuste.$dirty) return errors;
      !this.$v.editar_item.tipo_ajuste.required && errors.push("Campo Obrigatório.");
      return errors;
    },
    PERCENTUAL_AJUSTE_ERRORS() {
      const errors = [];
      if (!this.$v.editar_item.percentual_ajuste.$dirty) return errors;
      !this.$v.editar_item.percentual_ajuste.required && errors.push("Campo Obrigatório.");
      !this.$v.editar_item.percentual_ajuste.ajusteValido && errors.push("Redução máxima é de 99%.");
      return errors;
    }
  },
  methods: {
    editar() {
      this.$v.$touch();

      if (!this.$v.$invalid) {
        let parametros = {
          grupo: this.editar_item.id_grupo,
          filial: this.editar_item.filial,
          lote_minimo: this.editar_item.lote_minimo,
          tempo_ressuprimento: this.editar_item.tempo_medio_ressuprimento,
          produtos: []
        };

        if (this.produtos_selecionados.length == 0) {
          parametros.produtos = [this.editar_item];
        } else {
          parametros.produtos = this.produtos_selecionados;
        }

        this.$store.dispatch(
          'loading/addRequisicao',
          salvarEditarProdutos(parametros)
            .then(() => {
              this.$emit('atualizar-tela-inicial');
              this.dialog = false;
            })
            .catch(() => this.Helpers.logout())
        )
      }
    }
  }
}
</script>

<style>

</style>
